'use client'

import { motion } from 'framer-motion'
import Image from 'next/image'

export default function CreatorCard({ creator }) {
    const handleClick = () => {
        // Remove the @ symbol from the username for the URL
        const username = creator.username.replace('@', '')
        window.open(`/${username}`, '_blank')
    }

    return (
        <motion.div
            whileHover={{ scale: 1.05 }}
            className="flex-none w-64 bg-neutral-900 rounded-lg overflow-hidden transition-transform duration-300 cursor-pointer"
            onClick={handleClick}
        >
            <div className="h-64 w-full overflow-hidden">
                <div className="h-full w-full bg-gradient-to-br from-indigo-500 to-purple-500 animate-gradient-xy">
                    {creator.image ? (
                        <Image
                            src={creator.image}
                            alt={creator.name}
                            width={256}
                            height={256}
                            className="w-full h-full object-cover"
                        />
                    ) : (
                        <div className="w-full h-full bg-neutral-800 opacity-75" />
                    )}
                </div>
            </div>
            <div className="p-4">
                <h3 className="text-lg font-medium text-white">
                    {creator.name}
                </h3>
                <p className="text-sm text-gray-400">{creator.bio}</p>
                <p className="text-indigo-400 text-sm mt-1">
                    {creator.username}
                </p>
            </div>
        </motion.div>
    )
}

// Skeleton loader for when data is being fetched
CreatorCard.Skeleton = function CreatorCardSkeleton({ count = 1 }) {
    return Array(count)
        .fill(0)
        .map((_, i) => (
            <div
                key={i}
                className="flex-none w-64 bg-neutral-900 rounded-lg overflow-hidden animate-pulse"
            >
                <div className="h-64 w-full bg-neutral-800" />
                <div className="p-4 space-y-3">
                    <div className="h-5 bg-neutral-800 rounded w-2/3" />
                    <div className="h-4 bg-neutral-800 rounded w-1/2" />
                    <div className="h-4 bg-neutral-800 rounded w-1/3" />
                </div>
            </div>
        ))
}
